
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CasillaActualService } from 'src/app/services/casilla-actual.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { environment } from 'src/environments/environment';
import { UsuariosService } from 'src/app/services/usuarios.service';
import { ToastService } from 'src/app/shared/services/toast.service';
import * as CryptoJS from 'crypto-js';
import { AppStore } from 'src/app/core/store/app.store';
import {LoginSiFirmaRequest} from "../../login.store.model";

@Component({
  selector: 'app-login-sifirma',
  templateUrl: './login-sifirma.component.html',
  styleUrls: ['./login-sifirma.component.scss']
})
export class LoginSifirmaComponent implements OnInit {

  form: FormGroup;
  urlReturn: string = "";
  datosUsuario: {
    usuario: string,
    clave: string
  } = {
      usuario: "",
      clave: ""
    }

    loginSiFirmaRequest: LoginSiFirmaRequest;

    registroUsuarioDatos:{
      tipoRegistro: number,
      pais: number,
      tipoDocumento: number,
      uNroDocumento: string,
      dRazonSocial: string
    } = {
      tipoRegistro: 1,
      pais: 1,
      tipoDocumento: 13,
      uNroDocumento: "",
      dRazonSocial: ""
    }

  constructor(
    private fb: FormBuilder,
    private appStore: AppStore,
    private casillaActual: CasillaActualService,
    private router: Router,
    private route: ActivatedRoute,
    private usuariosService: UsuariosService,
    private toast: ToastService
  ) {
    // this.addStyleSheet();
    // console.log('RUTA:', router.url);
    // console.log('RUTA_PARAM:', route.snapshot.params.returnUrl);  // to print only path eg:"/login"
  }

  ngOnInit() {
    //this.buildForm();
    var str = this.router.url; 
    var splitted = str.split("ReturnUrl=", 2); 
    this.urlReturn = splitted[1];
    this.urlReturn = this.urlReturn.replace("%2F%2F", "//");
    //console.log("url",this.urlReturn );
  }

  private buildForm() {
    this.form = this.fb.group({
      tipoDocumento: [document.createElement('txtPassword'), Validators.required],
      documentoIdentidad: [null, Validators.required],
      clave: [document.createElement('txtUserName'), Validators.required]
    });
    //console.log(this.form);
  }

  handleSiFirma = () => {
    if (this.datosUsuario.usuario == "") {
      this.toast.error("Por favor ingresa el usuario");
    }
    else if (this.datosUsuario.clave == "") {
      this.toast.error("Por favor ingresa tu contraseña");
    }
    else {
      this.loginSiFirmaRequest = {
        pcUsuario: this.datosUsuario.usuario,
        pcClave: this.datosUsuario.clave
      }
      //this.usuariosService.validarAccesoSiFirma(this.datosUsuario.usuario, this.encriptarClave(this.datosUsuario.clave)).subscribe((response) => {
      //this.usuariosService.validarAccesoSiFirma(this.datosUsuario.usuario, this.datosUsuario.clave).subscribe((response) => {
      this.usuariosService.validarAccesoSiFirma(this.loginSiFirmaRequest).subscribe((response) => {
        if (response.rptTipo == 1) {
          this.casillaActual.setSesion(response.token);
          this.appStore.sessionAction.login(response.token);
          const sesion = this.casillaActual.getSesion();
          const sesion2 = this.appStore.sessionAction.getUserSesion();
          //this.router.navigate(['/dashboard/']);

          //console.log(this.appStore.sessionAction.getUserSesion());
          //let token = this.route.snapshot.queryParamMap.get('token');
          let token = this.appStore.sessionAction.isToken();
          //location.href = "http://sifirmademo.pvn.gob.pe/?token=" + token; //environment.loginUrl + window.location.origin;
          location.href = this.urlReturn + "/?token=" + token;
        }
        else {
          this.toast.error(response.rptMsg);
        }
      });
    }
  }

  encriptarClave = (dato: string): string => { 
    var key = CryptoJS.enc.Utf8.parse('7061737323313233');
        var iv = CryptoJS.enc.Utf8.parse('7061737323313233');
        var encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(dato), key,
            {
                keySize: 128 / 8,
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
            });
        return encrypted.toString();
  };

}
